/*

	onePredictiveSearch 2.0.0 Usage (Webpack)
	alyssa @onerockwell
		↓↓↓↓
	onePredictiveSearchBar
	(it's onePredictiveSearch but modified by kamil @onerockwell to make separate predictive search for header search bar (and leave the default one for search results page))

*/

// Import all dependencies here
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

// import '../../styles/modules/yourModuleCallName.scss';

import SearchBarResultsTemp from '@/templates/template-onePredictiveSearchBarResults.html';

// Define the Backbone View here (Optional)
let OnePredictiveSearchBarView = Backbone.View.extend({
  initialize: function (settings) {
    var self = this;

    console.log('init predictive search bar');

    self.initSearchResults();
    self.resetInput();
    self.closeResults();
  },

  events: {},

  initSearchResults: function () {
    var self = this;

    $('#SearchBarForm input').keyup(function () {
      var q = $(this).val();

      $('.predictive-search-bar--search-template').empty();

      $('.predictive-search-bar-form').addClass('input-active');

      if ($(this).val() == '') {
        $('.predictive-search-bar-form').removeClass('input-active');
      }

      $.ajax('/search/suggest.json?q=' + q + '&section_id=predictive-search', {
        type: 'GET',
        dataType: 'json', // added data type
        success: function (response) {
          console.log(response);

          var querySuggestions = response.resources.results.queries;
          var productSuggestions = response.resources.results.products;
          var pageSuggestions = response.resources.results.pages;

          var productResultsNumber = response.resources.results.products.length;
          var queryResultsNumber = response.resources.results.queries.length;
          var searchUrl = `/search?q=${q}`;

          var content = self.buildTemplate({
            response: response,
            querySuggestions: response.resources.results.queries,
            productSuggestions: response.resources.results.products,
            searchPageResults: '#predictive-search',
            productResultsNumber: productResultsNumber,
            queryResultsNumber: queryResultsNumber,
            searchQuery: q,
            searchUrl: searchUrl
          });

          self.$search = $('.predictive-search-bar--search-template').append(
            content
          );
        }
      });
    });
  },

  resetInput: function () {
    $('.reset__button').on('click', function (e) {
      e.preventDefault();
      // console.log($(this).parent().find('input')[0].value);
      $(this).parent().find('input')[0].value = '';
      $(this).parent().find('input')[0].focus();
      $('.predictive-search-bar-form').removeClass('input-active');
    });
  },

  closeResults: function () {
    document.addEventListener('click', function (e) {
      var inputForm = document.getElementById('SearchResult'),
        targetEl = e.target; // clicked element
      do {
        if (targetEl == inputForm) {
          // This is a click inside, does nothing, just return.
          return;
        }
        // Go up the DOM
        targetEl = targetEl.parentNode;
      } while (targetEl);
      // This is a click outside.
      $('.predictive-search-bar--search-template').empty();
    });
  },

  buildTemplate: function (content, type) {
    var self = this,
      typeTemplate;

    switch (type) {
      case '':
        break;
      default:
        typeTemplate = SearchBarResultsTemp;
        break;
    }

    return typeTemplate({ content: content });
  },

  destroy: function () {
    var self = this;
    self.undelegateEvents();
  }
});

// Define the module here
let OnePredictiveSearchBar = {
  init: function (settings) {
    return new OnePredictiveSearchBarView(settings);
  }
};

// Output the module
export default OnePredictiveSearchBar;
